/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';

import * as commonSagas from '../_common/commonSagas';
import * as cardsSlice from './cardsSlice';

export default function* watchCardsSaga() {
 yield takeLatest(cardsSlice.getTableStart.type, commonSagas.getTable);
 yield takeLatest(cardsSlice.getItemStart.type, commonSagas.getItem);
 yield takeLatest(cardsSlice.createItemStart.type, commonSagas.createItem);
 yield takeLatest(cardsSlice.updateItemStart.type, commonSagas.updateItem);
 yield takeLatest(cardsSlice.deleteItemsStart.type, commonSagas.deleteItems);
 yield takeLatest(cardsSlice.deleteItemStart.type, commonSagas.deleteItem);
 yield takeLatest(
  cardsSlice.getTableStructureStart.type,
  commonSagas.getTableStructure,
 );
 yield takeLatest(
  cardsSlice.getItemDocumentsStart.type,
  commonSagas.getItemDocuments,
 );
 yield takeLatest(
  cardsSlice.uploadItemDocumentsStart.type,
  commonSagas.uploadItemDocuments,
 );
 yield takeLatest(
  cardsSlice.deleteItemDocumentStart.type,
  commonSagas.deleteItemDocument,
 );
 yield takeLatest(
  cardsSlice.getTableExcelStart.type,
  commonSagas.getTableExcel,
 );
}

